<template>
  <div class="mobWrapper">
    <Navigation/>
    <slot/>
    <helper-modal/>
    <whats-app-button/>
    <footer-component/>
  </div>
</template>
<script setup lang="ts">
import {watch} from "vue";
import FooterComponent from "~/components/FooterComponent.vue";
import Navigation from "~/components/Navigation.vue";
import WhatsAppButton from "~/components/buttons/WhatsAppButton.vue";

const removeElement = ref()
const {$viewport} = useNuxtApp()

watch($viewport.breakpoint, (newBreakpoint) => {
  if (['tablet', 'desktop'].includes(newBreakpoint)) {
    removeElement.value = false;
  } else {
    removeElement.value = true;
  }
})
</script>
<style>
</style>